/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamListElementList = {
    type: 'array',
    contains: {
        type: 'TeamListElement',
    },
} as const;
